import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { IMAGES, CONTACT } from "@/data/site";
import { Reveal, SectionKicker } from "./Reveal";

export const About = () => {
  const { t } = useLang();
  const a = t.about;

  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="py-24 sm:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="container-x grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="relative">
            <div className="relative overflow-hidden rounded-3xl border border-white/10">
              <img
                src={IMAGES.about}
                alt="Ángel Robles — Angel Cars Upholstery Service"
                loading="lazy"
                className="w-full aspect-[4/3] object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            <div className="absolute -top-5 -left-3 sm:left-6 bg-brand text-white rounded-2xl px-5 py-3 shadow-xl">
              <div className="font-heading text-3xl font-extrabold leading-none">+8</div>
              <div className="text-[11px] uppercase tracking-wider">{t.hero.stat1}</div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <SectionKicker>{a.kicker}</SectionKicker>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {a.title}
          </h2>
          <div className="mt-6 space-y-4 text-zinc-400 leading-relaxed">
            <p>{a.p1}</p>
            <p>{a.p2}</p>
            <p>{a.p3}</p>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            {a.tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-white"
              >
                <CheckCircle2 className="h-4 w-4 text-brand" />
                {tag}
              </span>
            ))}
          </div>
          <div className="mt-8 flex items-center gap-3">
            <div className="h-12 w-12 rounded-full bg-brand/15 grid place-items-center font-heading font-bold text-brand text-lg">
              AR
            </div>
            <div>
              <div className="font-heading font-semibold text-white">{CONTACT.owner}</div>
              <div className="text-xs text-zinc-400">Founder · Angel Cars Upholstery</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
